import { actionTypes } from 'actions/clinicManager';

const initialState: IClinicManagerState = {
  clinicName: '',
  clinicId: '',
};

export default (
  state: IClinicManagerState = initialState,
  action: Action<any>,
): IClinicManagerState => {
  switch (action.type) {
    case actionTypes.SELECT_CLINIC_MANAGER: {
      return {
        ...state,
        clinicName: action.payload.clinicName,
        clinicId: action.payload.clinicId,
      };
    }
    case actionTypes.DEFAULT_STATE:
      return initialState;
    default: {
      return state;
    }
  }
};
